import './Card.css';

import React from 'react';
import Hammer from 'react-hammerjs';
import classnames from 'classnames';

export default class Card extends React.Component {
  /**
   * User is panning the card
   * @param {*} event
   */
  handlePan(event) {
    if (event.deltaX === 0) return;
    if (event.center.x === 0 && event.center.y === 0) return;
    if (this.props.locked) return;

    const xMulti = event.deltaX * 0.03;
    const yMulti = event.deltaY / 80;
    const rotate = xMulti * yMulti;

    // Too expensive to rerender the card on pan
    // So update the el directly
    event.target.style.transform = 'translate(' + event.deltaX + 'px, ' + event.deltaY + 'px) rotate(' + rotate + 'deg)';

    // Highlight the side
    event.target.closest('.Game').classList.toggle('positive', event.deltaX > 0); // pan right
    event.target.closest('.Game').classList.toggle('negative', event.deltaX < 0); // pan left
  }

  handlePanEnd(event) {
    if (this.props.locked) return;
    // Run panEnd handler from parent
    this.props.handlePanEnd(this.props.index, event);
  }

  handlePanStart() {
    if (this.props.locked) return;

    this.props.handlePanStart(this.props.index);
  }

  onAnimationEnd(event) {
    this.props.flipCallback(event, this.props.index);
  }

  render() {
    const classes = classnames(
      'Card',
      this.props.classes, // whether to add 'is-moving' or not
    )

    const bgClasses = classnames(
      'Card-bg',
      {'flipNoScale': this.props.flipped},
      {'flipBack': this.props.reversed}
    )

    return (
      <Hammer onPan={this.handlePan.bind(this)} onPanEnd={this.handlePanEnd.bind(this)} onPanStart={this.handlePanStart.bind(this)}>
        {/* Outer div is for panning */}
        <div className={classes} style={this.props.style} data-behavior={this.props.behavior} data-counter={this.props.counter} onAnimationEnd={this.onAnimationEnd.bind(this)}>

          {/* Div for the translateY on the card in the deck position */}
          <div className="Card-deck" style={this.props.deckCardStyle}>

            {/* Div for the flip transform on the background */}
            <div className={bgClasses} data-value={this.props.value}>
              {/* Write the text in the card for screen readers */}
              <span className="sr-only">{this.props.text}</span>
            </div>

          </div>
        </div>
      </Hammer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/rlgl/Card/Card.js